module.exports = __webpack_public_path__ + "static/img/button.40ae39a4.png";